import { useNavigate } from "react-router-dom";
import BackBtn from "../../compoment/icon/BackBtn";
import User from "../../compoment/icon/User";
import Users from "../../compoment/icon/Users";

const JoiningTodayScreen = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate("/selected-lantern");
    };

    const handleJoinToday = (join: string) => {
        localStorage.setItem('join', join)
        navigate('/choose-avatar')
    }

    return (
        <>
            <section className="colorSection portraitDevice">
                <div className="mainContainerSection">
                    <div>
                        <button className="backBTN" onClick={handleBack}>
                            <span className="me-2"><BackBtn /></span> Back
                        </button>
                    </div>
                    <div className="headingJoining mt-0">{`Who’s joining you today?`}</div>
                    <div className="lanternContainer" style={{ columnGap: 32 }}>
                        <div className="singleLanternJoining" onClick={() => handleJoinToday('I am on my own')}>
                            <div> <User />  </div>
                            <button className="lanternBtn">I am on my own</button>
                        </div>
                        <div className="singleLanternJoining" onClick={() => handleJoinToday('I am with my friend')}>
                            <div><Users /></div>
                            <button className="lanternBtn">I am with my friend</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default JoiningTodayScreen;
